import { IIconBase } from '..'

const calendarIcon = ({
  color = '#000000',
  height = 16,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      version='1.0'
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 512.000000 512.000000'
      preserveAspectRatio='xMidYMid meet'
    >
      <g
        transform='translate(0.000000,512.000000) scale(0.100000,-0.100000)'
        fill={color}
        stroke='none'
      >
        <path
          d='M1535 4786 c-37 -17 -70 -52 -84 -89 -6 -16 -11 -103 -11 -203 l0
        -174 -348 0 c-280 0 -359 -3 -407 -15 -172 -45 -305 -179 -350 -352 -23 -86
        -23 -3180 0 -3266 45 -173 178 -307 350 -352 52 -13 277 -15 1875 -15 1598 0
        1823 2 1875 15 172 45 305 179 350 352 23 86 23 3180 0 3266 -45 173 -178 307
        -350 352 -48 12 -127 15 -406 15 l-348 0 -3 189 c-3 207 -6 216 -72 265 -39
        29 -133 29 -172 0 -66 -49 -69 -58 -72 -265 l-3 -189 -799 0 -799 0 -3 189
        c-3 207 -6 216 -70 264 -34 25 -113 32 -153 13z m-93 -975 c3 -207 6 -216 72
        -265 39 -29 133 -29 172 0 66 49 69 58 72 265 l3 189 799 0 799 0 3 -189 c3
        -207 6 -216 72 -265 39 -29 133 -29 172 0 66 49 69 58 72 265 l3 190 349 -3
        c334 -3 350 -4 376 -24 15 -11 37 -33 48 -48 20 -26 21 -42 24 -376 l3 -349
        -190 -3 c-207 -3 -216 -6 -265 -72 -29 -39 -29 -133 0 -172 49 -66 58 -69 265
        -72 l189 -3 -2 -1069 c-3 -1062 -3 -1069 -24 -1096 -11 -15 -33 -37 -48 -48
        l-27 -21 -1819 0 -1819 0 -27 21 c-15 11 -37 33 -48 48 -21 27 -21 34 -24
        1097 l-2 1069 1549 2 c1547 3 1550 3 1577 24 53 39 69 71 69 134 0 63 -16 95
        -69 134 -27 21 -30 21 -1577 24 l-1549 2 0 334 c0 347 2 370 43 415 45 48 59
        50 419 51 l337 0 3 -189z'
        />
      </g>
    </svg>
  )
}

export default calendarIcon
